var boostPFSFilterConfig = {
  ...boostPFSFilterConfig,
  general: {
    ...boostPFSFilterConfig?.general,
    paginationType: "load_more",
    limit: 60,
    placeholderImageRatio: 1
  }
};


const groups = theme.settings.productGroups.split(",")
  

//PLP group
class PLPGroup extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this._attrs = {
      action: "data-plp-group-action",
      title: "data-plp-group-title",
      empty: "data-plp-group-empty",
      productsList: "data-plp-group-products"
    }
    this._group = this.getAttribute("group");

    this._initTemplate();
    this._initElements();
    this._initEvents();
    
    this._populate();
  }

  _scrollToViewIfRequired() {
    if (window.plpGroupHash === `#${this.id}`) {
      this.scrollIntoView();
    }
  }

  _initTemplate() {
    const template = document.getElementById('plp-group-template').content.cloneNode(true);
    this.appendChild(template);
  }

  _initElements() {
    this._$title = this.querySelector(`[${this._attrs.title}]`);
    this._$empty = this.querySelector(`[${this._attrs.empty}]`);
    this._$productsList = this.querySelector(`[${this._attrs.productsList}]`)
  }

  _initEvents() {
    this.addEventListener("click", this._onClick.bind(this))
    this._$productsList.addEventListener("scroll", debounce(() => this._syncActionButtons(), 300).bind(this));
  }

  _initSlideWidth() {
    this.classList.toggle("plp-group--slider", this._$productsList.clientWidth < this._$productsList.scrollWidth)

    if (this._$productsList.childElementCount) {
      this._slideWidth = this._$productsList.scrollWidth / this._$productsList.childElementCount;
    }
    
    this._syncActionButtons()
  }

  _onClick(evt) {
    this._onActionClick(evt)
  }

  _onActionClick(evt) {
    const $el = evt.target.closest(`[${this._attrs.action}]`);

    if(!$el) return;

    if ($el.getAttribute(this._attrs.action) === "next") {
      this._$productsList.scrollLeft += this._slideWidth;
    } else {
      this._$productsList.scrollLeft -= this._slideWidth;
    }
  }

  _syncActionButtons() {
    this.classList.remove("plp-group--lock-next")
    this.classList.remove("plp-group--lock-prev")

    if (this._$productsList.scrollLeft >= this._$productsList.scrollWidth - this._$productsList.clientWidth) {
      this.classList.add("plp-group--lock-next");

      return;
    }

    if (this._$productsList.scrollLeft <= 0) {
      this.classList.add("plp-group--lock-prev");

      return;
    }
  }

  _populate() {
    this._$title.textContent = this._group;
  }

  _checkEmpty() {
    this.classList.toggle("plp-group--empty", this._$productsList.childElementCount === 0)
    this._initSlideWidth();
  }

  appendProducts($products) {
    const fragment = document.createDocumentFragment();
    $products.forEach($product => fragment.appendChild($product))
    this._$productsList.appendChild(fragment);

    this._checkEmpty()
  }

  clearProducts() {
    this._$productsList.innerHTML = ""
  }
}

customElements.define("plp-group", PLPGroup)
// END OF PLP group

ProductList.prototype.setData = function(data) {
  this.data = data;
  this.totalProduct = this.parent.totalProduct;
  this.prepareProductData();
  this.eventType = this.parent.eventType;
  this.eventInfo = this.parent.eventInfo,
  // Clear all the product item component
  this.children = [];
  this.productItems = [];
  // Define the ajaxpage for Build product list by Ajax
  this.ajaxPage = 0;

  if (this.totalProduct > 0) {
    // Add product item compoment
    const ProductItemClass = this._getProductItemClass();
    data.forEach((productdata, index) => {
      var productItem = new ProductItemClass();
      this.addComponent(productItem);
      productItem.setData(productdata, index);
      this.productItems.push(productItem);
    });
  }
}

ProductList.prototype.buildProductList = function() {
  if (!this.productGroupsGenerated) this.generatePLPGroups();

  if (Globals.queryParams.page === 1) {
    this.generatePLPGroups();
  }

  const groupedProductItems = {};

  groups.forEach(group => {
    const groupString = `Group::${group}`;

    groupedProductItems[group] = this.productItems.filter(item => item.data.tags.includes(groupString));
  })

  for (const key in groupedProductItems) {
    if (Object.hasOwnProperty.call(groupedProductItems, key)) {
      const productItems = groupedProductItems[key];
      this.groups[key].section.appendProducts(productItems.map(item => item.$element[0]))
    }
  }

  // Remove the sort by attribute of product list element
  this.$element.removeAttr('data-boost-sort');  

  Integration.call3rdAppFunction(this.data);
  Integration.call3rdIntegrationFunc(this.data);

  const params = Globals.queryParams
  const totalPage = Math.ceil(this.totalProduct / params.limit);
  const currentPage = parseInt(params.page);
  if (currentPage < totalPage) {
    FilterApi.setParam("page", currentPage + 1);
    FilterApi.applyFilter("page");
  }

  // Re-call afterRender to add additional feature for product list
  if (this.settings.loadProductFromLiquid && this.settings.loadProductFromLiquidType == ProductList.Enum.loadProductType.AJAX) {
    this.afterRender();
  }
}

ProductList.prototype.generatePLPGroups = function() {
  this.groups = {}
  this.$element.html('');
  groups.forEach(group => {
    const section = document.createElement("plp-group");

    section.setAttribute("group", group);
    section.setAttribute("id", Utils.slugify(group))
    section.classList.add("plp-group")

    this.groups[group] = {
      section,
      type: group,
    }
    this.$element.append(section);
  })

  this.productGroupsGenerated = true
}

ProductList.prototype.clearProductsFromPLPGroups = function() {
  Object.values(this.groups).forEach(group => {
    section.clearProducts();
  })
}

ProductListPlaceholder.prototype.getTemplate = function() {
  return boostPFSTemplate.productListPlaceholderHtml
}

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}